import { Form } from 'react-bootstrap';
import { NewRequestTableRowProps } from '../../models/dashboard-models';
import React from "react";
import {useTranslation} from "react-i18next";

export const NewRequestTableRow: React.FC<NewRequestTableRowProps> = ({
    children,
    label,
    id,
    labelContainerClass,
    inputContainerClass,
    editForm,
    required,
    hideBottomBorder,
}: NewRequestTableRowProps) => {
    const { t } = useTranslation('translation', { keyPrefix: 'newRequest' });
    const labelFont = editForm ? 'default-font-size' : '';
    const flexRowItems = editForm ? 'd-flex mb-3' : 'd-flex';
    const flexFormItems = editForm ? 'd-flex flex-block' : 'w-75 flex-center';

    const errorMessage = typeof required === 'object' && required?.message
        ? (required.message.startsWith('*') ? required.message : '*' + required.message)
        : '*' + t('required');

    return (
        <tr className={`${flexRowItems} w-100 ${hideBottomBorder ? 'border-bottom-0' : ''}`}>
            <td className={`py-0 d-flex w-35 align-items-center ${hideBottomBorder ? 'border-bottom-0' : ''} ${labelContainerClass ?? ''}`}>
                <div>
                    <span className={`w-100 d-inline-block m-0 py-1 ${labelFont}`}>{label}</span>
                    { required && <p className={`input-error mb-2`}>{errorMessage}</p>}
                </div>
            </td>
            <td className={`pe-1 p-0 ${flexFormItems} ${hideBottomBorder ? 'border-bottom-0' : ''}`}>
                <Form.Group
                    controlId={`${id}`}
                    className={`w-100 me-1 d-flex align-items-center  ${inputContainerClass ?? ''}`}
                    style={{ padding: '4px 0px' }}
                >
                    {children}
                </Form.Group>
            </td>
        </tr>
    );
};
